/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProposalClientResource
 */
export interface ProposalClientResource {
    /**
     * 
     * @type {string}
     * @memberof ProposalClientResource
     */
    identityId: string;
    /**
     * 
     * @type {string}
     * @memberof ProposalClientResource
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof ProposalClientResource
     */
    photoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ProposalClientResource
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof ProposalClientResource
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof ProposalClientResource
     */
    companyLogoUrl?: string;
}

/**
 * Check if a given object implements the ProposalClientResource interface.
 */
export function instanceOfProposalClientResource(value: object): value is ProposalClientResource {
    if (!('identityId' in value) || value['identityId'] === undefined) return false;
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    return true;
}

export function ProposalClientResourceFromJSON(json: any): ProposalClientResource {
    return ProposalClientResourceFromJSONTyped(json, false);
}

export function ProposalClientResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalClientResource {
    if (json == null) {
        return json;
    }
    return {
        
        'identityId': json['identityId'],
        'fullName': json['fullName'],
        'photoUrl': json['photoUrl'] == null ? undefined : json['photoUrl'],
        'companyId': json['companyId'],
        'companyName': json['companyName'],
        'companyLogoUrl': json['companyLogoUrl'] == null ? undefined : json['companyLogoUrl'],
    };
}

export function ProposalClientResourceToJSON(value?: ProposalClientResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'identityId': value['identityId'],
        'fullName': value['fullName'],
        'photoUrl': value['photoUrl'],
        'companyId': value['companyId'],
        'companyName': value['companyName'],
        'companyLogoUrl': value['companyLogoUrl'],
    };
}

